<template>
    <div>

        <div class="position-relative">
            <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">Careers
                                </h1>
                                <p class="lead  text-white">
                                    Join us to promote the in-depth development of artificial intelligence.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        
        <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="img/career_misson.jpg" class="img-fluid">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <h3 class="text-white">Mission</h3>
                            <p class="lead text-white">We believe that AI is playing a more and more important role for modern enterprise activities. Magicom aim to enhance enterprise power with AI-enabled solutions. Our mission is to make that happen faster and easier for our customers.</p>
                            <p class="lead text-white">If you have vision and talent, we look forward to your joining us! Together with Magicom, we will contribute to enterprise intelligent solutions and promote the in-depth development of artificial intelligence.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-shaped section-lg my-0">
            <div class="shape shape-style-1 bg-gradient-default">
                <span class="span-150"></span>
                <span class="span-50"></span>
                <span class="span-50"></span>
                <span class="span-75"></span>
                <span class="span-100"></span>
            </div>
    
            <div class="container pt-lg">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Core Values</h2>
                        <p class="lead text-white">Core values ​​provide us with a framework for decision-making and effective team cooperation.</p>
                    </div>
                </div>
                <div class="row row-grid mt-5">
                    <div class="col-lg-6  order-lg-1">
                        <card shadow class="shadow-lg--hover mt-5">
                            <icon name="ni ni-calendar-grid-58" size="lg" gradient="white" shadow round color="primary"></icon>
                            <h5 class="mt-3">At the right time, do the right things right</h5>
                            <p class="mt-3">Timing is a particularly critical factor in the growth of a company. We need to maintain keen thinking and insight to grasp the right timing. And then do the right things right, which combines effectiveness (doing the right things) with efficiency (doing things right) to yield the most profitable and quickest route us to execute goals. Leaders manage time most productively at the intersection of effectiveness and efficiency. Doing the right thing is the basis and prerequisite, only after finding the right thing to do, then choosing the right way to do it.</p>
                        </card>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <card shadow class="shadow-lg--hover mt-5">
                            <icon name="ni ni-support-16" size="lg" gradient="white" shadow round color="success"></icon>
                            <h5 class="mt-3">Customer care, our top priority</h5>
                            <p class="mt-3">Magicom grows by loving our customers and contagiously telling everyone they know about Magicom. Customers are always looking to become more effective, more efficient and agile. They will continue to improve their standards and push us to become better, and we welcome challenges. We must meet the needs of customers as much as possible and put the needs of customers first. This is the only way to demonstrate the true value of our technologies. Without the needs of customers, even the best technology cannot reflect its own value.</p>
                        </card>
                    </div>
                </div>
                <div class="row row-grid mt-5">
                    <div class="col-lg-6 order-lg-1">
                        <card shadow class="shadow-lg--hover mt-5">
                            <icon name="ni ni-settings" size="lg" gradient="white" shadow round color="primary"></icon>
                            <h5 class="mt-3">Innovative technology, the key to success</h5>
                            <p class="mt-3">Artificial intelligence, machine learning and deep learning have been widely used in industries. Not only does it enable organizations to automate repetitive tasks, create personalized content and more user-friendly experiences, but it also gains insights to enhance and simplify operations. From autonomous driving cars to smart healthcare, retail management, and from simplifying content to building smart homes, artificial intelligence have undoubtedly played a good role.</p>
                        </card>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <card shadow class="shadow-lg--hover mt-5">
                            <icon name="ni ni-atom" size="lg" gradient="white" shadow round color="primary"></icon>
                            <h5 class="mt-3">Team cooperation, the spirit of enterprise</h5>
                            <p class="mt-3">We believe that in the combined power of collaborative, energetic, intelligent and highly honest individual teams, the advantage of a team is that it is not just the sum of its parts. We work together instead of fighting each other, because you are the simplest negative game with me. We push each other to improve, because when our individual becomes better, the whole team becomes better. We treat each other kindly, because respect and morale enable us all to do our best together.</p>
                        </card>
                    </div>
                </div>
            </div>
        </section>

         <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row row-grid justify-content-center">
                    <div class="col-lg-8 text-center">
                        <h2 class="display-3">
                            <span class="text-white">Open Positions</span>
                        </h2>
                        <p class="lead text-white">Let's promote the in-depth development of artificial intelligence. Please send your resume to <a href = "mailto: hr@magicom.io">hr@magicom.io</a> if you are interested in any position we posted.</p>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="col-lg-12 mt-5 mt-lg-0">
                    <tabs fill class="flex-column flex-md-row">
                        <card shadow>
                            <tab-pane title="Data Engineer">
                                <h5>Role</h5>
                                <p>We are looking for developers who implement impeccable data practices and implement high-quality data infrastructure. We value hard-working employees who are willing to build temporary solutions to big data challenges and at the same time build systems that can stand the test of time. Our ideal candidate has experience in building a data infrastructure from the ground up, has contributed innovative ideas and sophisticated implementation methods to the team, and is able to plan scalable and maintainable data pipelines.</p>
                                <p>As a data engineer, you will get real-time data from our customers and convert them into a combination of real-time and planned output. Your work will improve the quality of our results while reducing calculation costs and delays. Looking forward to truly novel challenges.</p>
                                <hr/>
                                <h5>Responsibilities</h5>
                                <ul>
                                    <li> 
                                        <p>Perform related data processing (data collection, data annotation, data cleaning, data augmentation, etc.) according to the customer's data processing plan.</p>                       
                                    <li> 
                                        <p>Assist business personnel to understand customer needs, complete customer needs analysis, and formulate data processing plans suitable for customers.</p>
                                    </li>
                                    <li> 
                                        <p>Cooperate with the quality inspection team to conduct quality inspections on processed data to ensure that all data processing meets customer requirements.</p>
                                    </li>
                                    <li> 
                                        <p>Responsible for documentation and log records during data processing, provide detailed data processing reports, and assist customers in project acceptance.</p>
                                    </li>
                                </ul>    
                                <hr/>
                                <h5>Requirements</h5>
                                <ul>
                                    <li> 
                                        <p>Be proficient in using computers, and be proficient in using the company's internal data annotation, data cleaning and data augmentation tools after training.</p>
                                    <li> 
                                        <p>Proficient in using various data collection equipment (video, audio\picture, text, etc.) to perform data collection tasks for different working environments.</p>
                                    </li>
                                    <li> 
                                        <p>Undergraduate and / or graduate degree in computer science or a similar technical field, with a sound understanding of data processing</p>
                                    </li>
                                    <li> 
                                        <p>At least 1-2 years of industry experience as a data engineer.</p>
                                    </li>
                                    <li> 
                                        <p>Understand commonly used computer software, and be able to use various image, audio and video processing software for data processing.</p>
                                    </li>
                                    <li> 
                                        <p>Have a strong job responsibility, great communication skills and ability to work with others.</p>
                                    </li>
                                </ul>
                                <!--div class="text-center">
                                    <base-button class="btn-1" type="primary">Apply for this position</base-button>
                                </div-->    
                            </tab-pane>

                            <tab-pane title="ML Engineer">
                                <h5>Role</h5>
                                <p>We are looking for developers who are excited to stay at the forefront of machine learning technology, prototype the most advanced deep learning models, and put these models into production. We value those staff who are proficient in processing big data, are interested in learning new technologies at all levels of the machine learning stack, and move quickly and have project ownership. Our ideal candidate has experience in creating machine learning-driven projects from the ground up, has contributed innovative ideas and sophisticated implementations to the team, and is able to plan scalable and maintainable data pipelines.</p>
                                <hr/>
                                <h5>Responsibilities</h5>
                                <ul>
                                    <li> 
                                        <p>Responsible for the research, development and implementation of image and video-based target monitoring, semantic recognition, image segmentation, target tracking, super-resolution, style transfer and other image and video-related machine learning algorithms, and implement them into actual application scenarios</p>                       
                                    <li> 
                                        <p>Responsible for the research, development and implementation of speech-related machine learning algorithms such as speech recognition, speech synthesis, and text-to-speech, and implement them in actual application scenarios</p>
                                    </li>
                                    <li> 
                                        <p>Responsible for the research and development and implementation of machine learning algorithms related to natural language processing such as text detection, text classification, semantic understanding, and knowledge graphs, and implement them in actual application scenarios</p>
                                    </li>
                                    <li> 
                                        <p>Responsible for the development of data collection, generation, cleaning and augmentation algorithms, and integrated into the company's AI platform.</p>
                                    </li>
                                    <li> 
                                        <p>Cooperate with the backend and frontend(H5, Android, and iOS) teams to deploy the developed algorithms to provide a stable and highly concurrent intelligent data service interface.</p>
                                    </li>
                                </ul>    
                                <hr/>
                                <h5>Requirements</h5>
                                <ul>
                                    <li> 
                                        <p> Undergraduate or graduate degree in computer science or similar technical field, experience in machine learning algorithm (image, NLP, video, or audio) development.</p>
                                    <li> 
                                        <p>Good technical background in machine learning(image, NLP, video, or audio), familiar with open source deep learning processing framework and basic algorithms.</p>
                                    </li>
                                    <li> 
                                        <p>Familiar with at least one deep learning model development framework including tensorflow, pytorch, mxnet, caffe2.</p>
                                    </li>
                                    <li> 
                                        <p>Familiar with linux development environment, with rich experience in python programming, enthusiasm for research and development, independent thinking and creativity are preferred.</p>
                                    </li>
                                    <li> 
                                        <p>Have a strong job responsibility, great communication skills and ability to work with others, excellent problem analysis and problem solving skills.</p>
                                    </li>
                                </ul>
                                <!--div class="text-center">
                                    <base-button class="btn-1" type="primary">Apply for this position</base-button>
                                </div--> 
                            </tab-pane>

                            <tab-pane title="ML Intern">
                                <h5>Responsibilities</h5>
                                <ul>
                                    <li> 
                                        <p>Research and develop machine learning solutions to help product cycle. Help quickly and accurately create high-quality training data</p>                       
                                    <li> 
                                        <p>Take the latest model developed internally or in the community and use it in production to solve the problems of our customers and task makers</p>
                                    </li>
                                    <li> 
                                        <p>Optimize the current model in production, identify areas for improvement, use retraining and hyperparameter search to improve it, and then deploy it.</p>
                                    </li>
                                    <li> 
                                        <p>Work with product and research teams to identify opportunities to improve our current product line and enable upcoming product lines.</p>
                                    </li>
                                    <li> 
                                        <p>Develop general models and fine-tuned models for specific products together with massive data sets.</p>
                                    </li>
                                </ul>    
                                <hr/>
                                <h5>Requirements</h5>
                                <ul>
                                    <li> 
                                        <p>Undergraduates who are currently pursuing a PhD or MS program, focusing on machine learning, deep learning, computer vision or natural language processing, or publishing papers in the field of machine learning</p>
                                    <li> 
                                        <p>Previous internships in machine learning, deep learning, computer vision or natural language processing is preferred.</p>
                                    </li>
                                    <li> 
                                        <p>Have a strong job responsibility, great communication skills and ability to work with others, excellent problem analysis and problem solving skills.</p>
                                    </li>
                                </ul>
                                <!--div class="text-center">
                                    <base-button class="btn-1" type="primary">Apply for this position</base-button>
                                </div--> 
                            </tab-pane>

                            <tab-pane title="Backend Engineer">
                              <h5>Role</h5>
                                <p>We are looking for developers who are excited about putting new products and features into production, who can work on their own and are not afraid to try new technologies, and do not shrink from scale challenges. Our ideal candidate has experience in building core services and web-based APIs from the ground up, cares about the product itself as much as the technology that supports it, and can construct and write clean, maintainable code.</p>
                                <hr/>
                                <h5>Responsibilities</h5>
                                <ul>
                                    <li> 
                                        <p>Responsible for the back-end API design and development, planning and deployment, monitoring and performance optimization of the company's data service platform.</p>                       
                                    <li> 
                                        <p>Cooperate with the machine learning team for the research and development of deep learning algorithms and the online deployment of deep learning models.</p>
                                    </li>
                                    <li> 
                                        <p>Responsible for the construction, development and deployment of SaaS cloud platform</p>
                                    </li>
                                    <li> 
                                        <p>Debug production issues across services and multiple levels of the stack.</p>
                                    </li>
                                </ul>    
                                <hr/>
                                <h5>Requirements</h5>
                                <ul>
                                    <li> 
                                        <p>Bachelor degree or above, computer-related major, more than 1 year of cloud computing industry research and development experience.</p>
                                    <li> 
                                        <p>Have experience in Golang, Java or Python back-end project development, familiar with Restful, RPC, microservices and other design concepts</p>
                                    </li>
                                    <li> 
                                        <p>Familiar of MySQL, Redis, MongoDB and other databases and caches. Familiar with container technology, familiar with docker related operations, familiar with Devops, Kubernetes container orchestration, service mesh experience is preferred.</p>
                                    </li>
                                    <li> 
                                        <p>Familiar with the open source deep learning framework tensorflow, pytorch, understand the deployment of deep learning models (such as tensorflow serving), and experience in big data development (Hadoop, Spark, Flink, Kafka, etc.) is preferred</p>
                                    </li>
                                    <li> 
                                        <p>Have a strong job responsibility, great communication skills and ability to work with others, excellent problem analysis and problem solving skills.</p>
                                    </li>
                                </ul>
                                <!--div class="text-center">
                                    <base-button class="btn-1" type="primary">Apply for this position</base-button>
                                </div-->
                            </tab-pane>

                            <tab-pane title="Web Engineer">
                              <h5>Role</h5>
                                <p>We are looking for developers who are passionate about front-end technology and thrive in a fast-paced environment. Use the latest web technologies such as React, Redux, Webpack and ES6 to provide innovative interfaces and rich user experience. With a small team and rapid changes, you will need to iterate quickly and make software design decisions based on product features. As a front-end engineer of Hive, your breadth of skills combined with our bottom-up product process will provide you with as much autonomy and responsibility as possible.</p>
                                <hr/>
                                <h5>Responsibilities</h5>
                                <ul>
                                    <li> 
                                        <p>Responsible for the company's html5 and web front-end page development.</p>                       
                                    <li> 
                                        <p>Participate in UI design, cooperate with back-end developers to complete the interactive functions of web page, and coordinate the work plan.</p>
                                    </li>
                                    <li> 
                                        <p>Complete the front-end framework, and the establishment and improvement of related documents.</p>
                                    </li>
                                    <li> 
                                        <p>Cooperate with the overall product team and assist in building an excellent team development environment and infrastructure.</p>
                                    </li>
                                </ul>    
                                <hr/>
                                <h5>Requirements</h5>
                                <ul>
                                    <li> 
                                        <p>Computer-related major, more than 1 year of front-end development experience is preferred.</p>
                                    <li> 
                                        <p>Proficient in javascript, css, html, dom and other front-end technologies, understand W3C, ECMAScript, CommonJS and other related standards</p>
                                    </li>
                                    <li> 
                                        <p>Proficient in ECMAScript5 core syntax, familiar with ES6 syntax, able to use React, Vue for component development. Familiar with front-end and back-end joint development methods, such as asynchronous data interaction.</p>
                                    </li>
                                    <li> 
                                        <p>Have a strong job responsibility, great communication skills and ability to work with others, excellent problem analysis and problem solving skills.</p>
                                    </li>
                                </ul>
                                <!--div class="text-center">
                                    <base-button class="btn-1" type="primary">Apply for this position</base-button>
                                </div-->
                            </tab-pane>

                            <tab-pane title="iOS Engineer">
                              <h5>Role</h5>
                                <p>We are looking for iOS developers with outstanding technical skills. You will be happy to accept feedback, and will work with open collaborators to prioritize team success. You are constantly learning and using new tools and techniques to expand your skills as a developer. You care about the user experience and refuse to release products that are mediocre to our users.</p>
                                <hr/>
                                <h5>Responsibilities</h5>
                                <ul>
                                    <li> 
                                        <p>Responsible for the design and iterative upgrade of our products on the app iOS system platform.</p>                       
                                    <li> 
                                        <p>Responsible for communication with the product manager, complete product development work.</p>
                                    </li>
                                    <li> 
                                        <p>Complete the construction, coding, testing, correction and optimization of the architecture and related modules according to application requirements and user experience.</p>
                                    </li>
                                    <li> 
                                        <p>Ensure the normal operation of the iOS product and maintenance and upgrade.</p>
                                    </li>
                                </ul>    
                                <hr/>
                                <h5>Requirements</h5>
                                <ul>
                                    <li> 
                                        <p>Computer-related major, more than 1 year of iOS development experience is preferred.</p>
                                    <li> 
                                        <p>Familiar with XCode, Object-C, Swift, Interface Builder and other development tools.</p>
                                    </li>
                                    <li> 
                                        <p>Proficient in iOS architecture and application development framework and iOS development environment.</p>
                                    </li>
                                    <li> 
                                        <p>Familiar with common data structures, algorithms and design patterns, familiar with common protocols such as TCP, HTTP and Socket.</p>
                                    </li>
                                    <li> 
                                        <p>Have a strong job responsibility, great communication skills and ability to work with others, excellent problem analysis and problem solving skills.</p>
                                    </li>
                                </ul>
                                <!--div class="text-center">
                                    <base-button class="btn-1" type="primary">Apply for this position</base-button>
                                </div-->
                            </tab-pane>

                            <tab-pane title="Android Engineer">
                              <h5>Role</h5>
                                <p>We are looking for Android developers with outstanding technical skills. You will be happy to accept feedback, and will work with open collaborators to prioritize team success. You are constantly learning and using new tools and techniques to expand your skills as a developer. You care about the user experience and refuse to release products that are mediocre to our users.</p>
                                <hr/>
                                <h5>Responsibilities</h5>
                                <ul>
                                    <li> 
                                        <p>Participate in product demand analysis and formulate technical implementation plans.</p>                       
                                    <li> 
                                        <p>Responsible for communication with the product manager, completing Android client program design, development, debugging and release.</p>
                                    </li>
                                    <li> 
                                        <p>Complete the development and unit testing of functional modules.</p>
                                    </li>
                                    <li> 
                                        <p>Responsible for independently development of multiple Android models and multiple system versions.</p>
                                    </li>
                                </ul>    
                                <hr/>
                                <h5>Requirements</h5>
                                <ul>
                                    <li> 
                                        <p>Computer-related major, more than 1 year of Android development experience is preferred.</p>
                                    <li> 
                                        <p>Proficient in Java, Kotlin and familiar with Android network communication, have a deep understanding and experience of TCP, HTTP and Socket.</p>
                                    </li>
                                    <li> 
                                        <p>Familiar with the characteristics of the Android platform, deeply understand the mobile client software and server development characteristics.</p>
                                    </li>
                                    <li> 
                                        <p>Proficient in the development skills of UI, network, database, XML/JSON analysis in Android.</p>
                                    </li>
                                    <li> 
                                        <p>Have a strong job responsibility, great communication skills and ability to work with others, excellent problem analysis and problem solving skills.</p>
                                    </li>
                                </ul>
                                <!--div class="text-center">
                                    <base-button class="btn-1" type="primary">Apply for this position</base-button>
                                </div-->
                            </tab-pane>
                        </card>
                    </tabs>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Tabs from "@/components/Tabs/Tabs.vue"
import TabPane from "@/components/Tabs/TabPane.vue"
export default {
  name: "careers",
  components: {
    Tabs,
    TabPane
  }
};
</script>
